import Vue from 'vue'
import Vuex from 'vuex'
import {coleccion_correo_remitente} from '@/FirebaseConfig'
import {cleanObject, secondsToFullTimestamp} from '@/Helper.js'  
Vue.use(Vuex)
export default {
    namespaced:true,
      state: {
        datos:{
            emisor: '',
            correo_electronico:'',
            createdAt:'',
        },
        registro:{},
        selectedKey: '',
        dialog: false,
      },
      mutations: {
        getAllItems(state, item) {
          Vue.set( state.registro, item.id, {...item.data(), createdAt: secondsToFullTimestamp(item.data().createdAt)} )
        },
        clean(state,key){
          Vue.delete(state.registro,key)
        }
      },
      actions: {
        
        getAll:(context)=>{
          context.state.registro = {}
          coleccion_correo_remitente.get().then(datos=>datos.docs.map( item => {context.commit( 'getAllItems', item  ) }) )
        },
        add:context=>{
          
          if(context.state.selectedKey==''){
            coleccion_correo_remitente.add({...context.state.datos, createdAt:new Date}).then(()=>{
              context.commit('Helpers/launchSnackbar', 'Se ha registrado un nuevo tipo de moneda correctamente', { root: true })
              cleanObject(context.state.datos)
              context.state.dialog = false
            })
          }else{
            coleccion_correo_remitente.doc(context.state.selectedKey).update(context.state.datos).then(()=>{
              context.commit('Helpers/launchSnackbar', ' Ha sido modificado correctamente', { root: true })
              cleanObject(context.state.datos)
              context.state.dialog = false
            })
          }
        },
        clean:(context, key)=>{
          coleccion_correo_remitente.doc(key).delete().then(()=>{
            context.commit('Helpers/launchSnackbar', ' Ha sido eliminado', { root: true })            
            context.commit('clean',key)})
        },
        get:(context, key)=>{
          coleccion_correo_remitente.doc(key).get().then(doc=>{
            context.state.datos = doc.data()
            context.state.selectedKey = key
            context.state.dialog = true
          })
        },
        clearForm:(context)=>{
          context.state.dialog = false
          context.state.selectedKey = ''
          context.state.datos = {
            emisor: '',
            correo_electronico:'',
            createdAt:'',
          }
        },
      },
      getters: {
        registro: state => Object.keys(state.registro).map(item => ({...state.registro[item], key: item }) ),
      },
  }
  